module.exports = __webpack_public_path__ + "static/dinner3-e12972ee87941a8c8ae5571755f497a9.jpg";